module.exports = __webpack_public_path__ + "static/rocksteadycrew-poster-1fd775f90b16ea58a9491d898f0c55de.jpg";